import { Body, Box, Icon } from '@hover/blueprint';
import { iconMail, iconPhone, iconUser } from '@hover/icons';
import type { IconProp } from '@hover/icons';
import type { ReactNode } from 'react';
import React from 'react';
import { useParams } from 'react-router-dom';

import { useGetProjectShareQuery } from 'src/shared/graphql/generated';

interface ContactInfoRowProps {
  icon: IconProp;
  children: ReactNode;
}

const ContactInfoRow: React.FC<ContactInfoRowProps> = ({ icon, children }) => (
  <Box alignItems="center">
    <Icon icon={icon} />
    <Body marginY={0}>{children}</Body>
  </Box>
);

export const DetailsContactInfo = () => {
  const { id } = useParams<{ id: string }>();
  const { data } = useGetProjectShareQuery({
    variables: { id },
  });

  if (!data?.projectShare?.creatingUser) return null;

  const {
    creatingUser: { name, email, phone },
  } = data.projectShare;

  return (
    <Box flexDirection="column" marginTop={600}>
      <ContactInfoRow icon={iconUser}>{name}</ContactInfoRow>
      {phone && <ContactInfoRow icon={iconPhone}>{phone}</ContactInfoRow>}
      <ContactInfoRow icon={iconMail}>{email}</ContactInfoRow>
    </Box>
  );
};
